import { types } from "mobx-state-tree";

export const ByokAddonModel = types.model({
  location: types.string,
  ignoreUpdates: types.maybe(types.boolean),
  config: types.maybe(
    types.model({
      actuator: types.maybe(
        types.model({
          minCpu: types.maybe(types.string),
          maxCpu: types.maybe(types.string),
          minMemory: types.maybe(types.string),
          maxMemory: types.maybe(types.string),
          logLevel: types.maybe(types.string), // 'trace', 'info', 'error'
          env: types.frozen(),
        }),
      ),
      common: types.maybe(
        types.model({
          deploymentReplicas: types.maybe(types.number), // min 0
          pdb: types.maybe(
            types.model({
              maxUnavailable: types.maybe(types.number), // min 0
            }),
          ),
        }),
      ),
      ingress: types.maybe(
        types.model({
          cpu: types.maybe(types.string),
          memory: types.maybe(types.string),
          targetPercent: types.maybe(types.number), // min 0
        }),
      ),
      internalDns: types.maybe(
        types.model({
          minCpu: types.maybe(types.string),
          maxCpu: types.maybe(types.string),
          minMemory: types.maybe(types.string),
          maxMemory: types.maybe(types.string),
        }),
      ),
      istio: types.maybe(
        types.model({
          istiod: types.maybe(
            types.model({
              replicas: types.maybe(types.number), // min 0
              minCpu: types.maybe(types.string),
              maxCpu: types.maybe(types.string),
              minMemory: types.maybe(types.string),
              maxMemory: types.maybe(types.string),
              pdb: types.maybe(types.number), // min 0
            }),
          ),
          ingressgateway: types.maybe(
            types.model({
              replicas: types.maybe(types.number), // min 0
              maxCpu: types.maybe(types.string),
              maxMemory: types.maybe(types.string),
            }),
          ),
          sidecar: types.maybe(
            types.model({
              minCpu: types.maybe(types.string),
              minMemory: types.maybe(types.string),
            }),
          ),
        }),
      ),
      longhorn: types.maybe(
        types.model({
          replicas: types.maybe(types.number), // min 1
        }),
      ),
      logSplitter: types.maybe(
        types.model({
          minCpu: types.maybe(types.string),
          maxCpu: types.maybe(types.string),
          minMemory: types.maybe(types.string),
          maxMemory: types.maybe(types.string),
          memBufferSize: types.maybe(types.string),
          perPodRate: types.maybe(types.number), // min 0
        }),
      ),
      monitoring: types.maybe(
        types.model({
          minMemory: types.maybe(types.string),
          maxMemory: types.maybe(types.string),
          kubeStateMetrics: types.maybe(
            types.model({
              minMemory: types.maybe(types.string),
            }),
          ),
          prometheus: types.maybe(
            types.model({
              main: types.maybe(
                types.model({
                  storage: types.maybe(types.string),
                }),
              ),
            }),
          ),
        }),
      ),
      middlebox: types.maybe(
        types.model({
          bandwidthAlertMbps: types.maybe(types.number), // min 0
          enabled: types.maybe(types.boolean),
        }),
      ),
      redis: types.maybe(
        types.model({
          minCpu: types.maybe(types.string),
          maxCpu: types.maybe(types.string),
          minMemory: types.maybe(types.string),
          maxMemory: types.maybe(types.string),
          storage: types.maybe(types.string),
        }),
      ),
    }),
  ),
});
